import React from "react";
import "./Preloader.css"; // Import the CSS file for styling

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="spinner"></div>
    </div>
  );
};

export default Preloader;
